import gameApi from 'api/gameApi';
import background from 'assets/images/background_poker.jpg';
import terabet_logo from 'assets/images/terabet_logo.png';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { IMG_ALT } from 'consts/app';
import { PlayGameResponseModel } from 'models';
import React, { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

interface GamePlayProps {}

const GamePlay: React.FunctionComponent<GamePlayProps> = () => {
  const { gameId } = useParams();
  const [searchParams] = useSearchParams();
  const [game, setGame] = useState<PlayGameResponseModel | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    if (gameId === 'poker') {
      if (window.innerWidth <= 1024) {
        navigate('/');
        return;
      }

      setIsLoading(true);
      const { ok, body } = await gameApi.playPoker();
      setIsLoading(false);

      if (ok && body) {
        setGame(body);
        return;
      }

      navigate('/');
      return;
    }

    if (!gameId) {
      navigate(-1);
      return;
    }

    setIsLoading(true);

    const { ok, body } =
      searchParams.get('fun') === '1'
        ? await gameApi.playForFun(gameId)
        : await gameApi.playGame(gameId);

    setIsLoading(false);

    if (ok && body) {
      setGame(body);
      return;
    }

    navigate(-1);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleClosePage = () => {
    navigate(-1);
  };

  return (
    <div className="game-play-page">
      {/* <div className="header">
        <img src={terabet_logo} alt={IMG_ALT} />
        <button className="close" onClick={handleClosePage}>
          <IoClose className="primary-text-color" style={{ fontSize: '24px' }} />
        </button>
      </div> */}
      <button className="close" onClick={handleClosePage}>
        <IoClose />
      </button>
      <div
        className={`game-frame ${gameId === 'poker' ? 'poker' : ''}`}
        style={{
          backgroundImage: `url('${gameId === 'poker' ? background : game?.game.imageBackground}')`,
        }}
      >
        <iframe title="game-screen" src={game?.url} />
      </div>
      {isLoading && (
        <div className="overlay">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default GamePlay;
